import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import HelpWidget from './components/feature/HelpWidget'
import ScrollToTop from './components/utils/ScrollToTop'
import { ThemeProvider } from './theme/ThemeProvider'

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
        <HelpWidget />
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
